export default __webpack_public_path__ + "static/media/brokenclouds.00a917a3.jpg";